var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.6173 1H6.38175C3.1622 1 1 3.2591 1 6.62115V14.3798C1 17.7409 3.1622 20 6.38175 20H14.6164C17.8359 20 20 17.7409 20 14.3798V6.62115C20 3.2591 17.8368 1 14.6173 1Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84748 9.78582H15.2625C15.652 9.78582 15.975 10.1088 15.975 10.4983V12.2558C15.975 12.6548 15.652 12.9683 15.2625 12.9683C14.8635 12.9683 14.55 12.6548 14.55 12.2558V11.2108H13.2865V12.2558C13.2865 12.6548 12.9635 12.9683 12.574 12.9683C12.175 12.9683 11.8615 12.6548 11.8615 12.2558V11.2108H9.84748C9.54348 12.2273 8.61248 12.9683 7.50098 12.9683C6.13298 12.9683 5.02148 11.8663 5.02148 10.4983C5.02148 9.13982 6.13298 8.02832 7.50098 8.02832C8.61248 8.02832 9.54348 8.76932 9.84748 9.78582ZM6.44629 10.4986C6.44629 11.0781 6.92129 11.5436 7.50079 11.5436C8.07079 11.5436 8.54579 11.0781 8.54579 10.4986C8.54579 9.91911 8.07079 9.45361 7.50079 9.45361C6.92129 9.45361 6.44629 9.91911 6.44629 10.4986Z",
    fill: "#EE9BFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.41b457ec05fe0e33a867db3be1a49015.svg";
export { ForwardRef as ReactComponent };